"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapAreaMask = void 0;
var Vector_1 = require("ol/layer/Vector");
var Vector_2 = require("ol/source/Vector");
var Style_1 = require("ol/style/Style");
var Fill_1 = require("ol/style/Fill");
var Stroke_1 = require("ol/style/Stroke");
var MapAreaMask = /** @class */ (function () {
    function MapAreaMask(feature) {
        var _this = this;
        this.feature = feature;
        this._layer = null;
        this.getMask = function () {
            if (_this._layer === null) {
                //create the layer
                _this._layer = new Vector_1.default({
                    source: new Vector_2.default(),
                    style: [
                        new Style_1.default({
                            fill: new Fill_1.default({
                                color: 'rgba(0,0,0,0.0)'
                            }),
                            stroke: new Stroke_1.default({
                                color: 'rgba(76,76,76,0.8)',
                                width: 5
                            })
                        })
                    ]
                    //minResolution: 50,
                    //maxResolution: 120000
                });
                _this._layer.getSource().addFeature(_this.feature);
            }
            return _this._layer;
        };
    }
    return MapAreaMask;
}());
exports.MapAreaMask = MapAreaMask;
//# sourceMappingURL=MapAreaMask.js.map